import React from "react"
import styled from "styled-components/macro"
import { BtnIconBox } from "../../Button/Button"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import ArrowIcon from "../../../images/iconmonstr-arrow-20.svg"
import "@fontsource/noto-sans-jp/700.css"
import colors from "../../../scripts/colors"

const HomeTaglineWrapStyles = styled(AnchorLink)`
  display: block;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 20px 42px 50px;
  position: relative;
  cursor: pointer;
  text-decoration: none;
  backdrop-filter: blur(4px);
  width: 100%;
  margin-top: -50px;
  margin-bottom: 100px;
  h1 {
    margin: 0;
    font-size: 35px;
    font-weight: 700;
    color: white;
    line-height: 1.2em;
    text-align: center;
    text-shadow: 0 2px 5px rgba(0, 0, 0, 1);
    @media screen and (min-width: 1500px) {
      font-size: 60px;
    }
  }
  .Cta-iconBtn {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -45px;
    cursor: pointer;
    background-color: ${colors("green", "lnk")};
    margin-right: 0;
    margin-left: 0;
    svg {
      transform: rotate(90deg);
    }
  }
  &:hover {
    .Cta-iconBtn {
      background-color: ${colors("green", "lnkhlt")};
    }
  }
  @media screen and (min-width: 550px) {
    margin-top: -95px;
    h1 {
      font-size: 45px;
    }
  }
  @media screen and (min-width: 1024px) {
    padding: 20px 42px 70px;
  }
  @media screen and (min-width: 1500px) {
    width: 500px;
    margin-top: -250px;
    margin-bottom: 0;
    padding: 20px 42px 100px;
    h1 {
      text-align: left;
      font-size: 60px;
    }
  }
`

const HomeTagline = ({ children }) => {
  return (
    <HomeTaglineWrapStyles to="#HomePage-homeIntroParagraph">
      <h1>{children}</h1>
      <BtnIconBox
        // tabindex="-1"
        // as="button"
        size="lg"
        className="Cta-iconBtn"
        // aria-label="Scroll down"
      >
        <ArrowIcon />
      </BtnIconBox>
    </HomeTaglineWrapStyles>
  )
}

export default HomeTagline
